import { Button, IOption } from '@netfront/ui-library';
import { TranslateImprovementStatusType } from 'interfaces';
import { Column } from 'react-table';

import { IGetTranslateImprovementsTableColumnsParams, ITranslateImprovementTableData } from './TranslateImprovementsTable.interfaces';

import { ExternalLink } from '../../../ExternalLink';

const ALL_STATUSES_OPTION_VALUE = '';

const TRANSLATE_IMPROVEMENT_STATUS_LABELS: Record<TranslateImprovementStatusType, string> = {
  APPROVED: 'Approved',
  DECLINED: 'Declined',
  PENDING: 'Pending',
};

const TRANSLATE_IMPROVEMENT_STATUS_OPTIONS: IOption[] = [
  { id: 'all', name: 'All statuses', value: ALL_STATUSES_OPTION_VALUE },
  ...(Object.keys(TRANSLATE_IMPROVEMENT_STATUS_LABELS) as TranslateImprovementStatusType[]).map((status) => ({
    id: status,
    name: TRANSLATE_IMPROVEMENT_STATUS_LABELS[status],
    value: status,
  })),
];

const getTranslateImprovementsTableColumns = ({
  onApproveOrDecline,
  processingIds,
}: IGetTranslateImprovementsTableColumnsParams): ReadonlyArray<Column<ITranslateImprovementTableData>> => [
  {
    accessor: 'url',
    Cell: ({ value }) => <div className="items-center flex gap-2">{value}   <ExternalLink href={value} isTooltipVisible /></div>,
    Header: () => <div>Page</div>,
  },
  {
    accessor: 'originalText',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>Original text</div>,
  },
  {
    accessor: 'proposedText',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>Proposed text</div>,
  },
  {
    accessor: 'language',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>Language</div>,
  },
  {
    accessor: 'status',
    Cell: ({ value }) => <div>{TRANSLATE_IMPROVEMENT_STATUS_LABELS[value]}</div>,
    Header: () => <div>Status</div>,
  },
  {
    id: 'actions',
    Cell: ({ row: { original } }) => {
      const { id } = original;

      const isProcessing = processingIds.includes(String(id));

      return (
        <div className="flex gap-2">
          <Button
            isDisabled={isProcessing}
            size="xs"
            text="Approve"
            type="button"
            onClick={() => onApproveOrDecline(String(id), true)}
          />
          <Button
            isDisabled={isProcessing}
            size="xs"
            text="Decline"
            type="button"
            variant="danger"
            onClick={() => onApproveOrDecline(String(id), false)}
          />
        </div>
      );
    },
    Header: () => <div>Actions</div>,
  },
];

export { getTranslateImprovementsTableColumns, TRANSLATE_IMPROVEMENT_STATUS_LABELS, TRANSLATE_IMPROVEMENT_STATUS_OPTIONS };
